import { render, staticRenderFns } from "./Progress-task.vue?vue&type=template&id=4bb1b2f0&scoped=true&"
import script from "./Progress-task.vue?vue&type=script&lang=js&"
export * from "./Progress-task.vue?vue&type=script&lang=js&"
import style0 from "./Progress-task.vue?vue&type=style&index=0&id=4bb1b2f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb1b2f0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loading: require('/opt/build/repo/components/Loading.vue').default})
